export type IMandatoryBarrierState = {
    barrierIds: number[]
}

export type IMandatoryActionsSetBarriers = {
    type: 'SET_MANDATORY_BARRIERS'
    payload: {
        newBarrierIds: number[]
    }
}

export type IMandatoryBarrierAction = IMandatoryActionsSetBarriers

const initialState: IMandatoryBarrierState = {
    barrierIds: []
}

export function mandatoryBarrierReducer(state = initialState, action: IMandatoryBarrierAction): IMandatoryBarrierState {
    switch (action.type) {
        case 'SET_MANDATORY_BARRIERS':
            return { ...state, barrierIds: action.payload.newBarrierIds }

        default:
            return state
    }
}
